export {
  BrandPage as default,
  getBydStaticProps as getStaticProps,
} from '@cinch-nx/landing-feature-brand-page'
